import React from 'react';
import { IIconProps } from '../interfaces';

const AleaCloseIcon: React.FC<IIconProps> = ({
  color = 'white',
  size = '34',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33325 27.7316L28.2898 5.5"
      stroke={color}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M28.2898 27.7314L5.33325 5.49987"
      stroke={color}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export default AleaCloseIcon;
